/* Help (13.1-11) — the page-head lede and the manual card, in the shell's language
 * (the Lookup page's lede; Card + Button's own classes for the panel and the two links). */

.intro {
  margin: 8px 0 28px;
  max-width: 66ch;
  font-size: 15px;
  color: var(--gray);
}

.card {
  max-width: 66ch;
}

.cardTitle {
  margin: 0;
  font-family: var(--serif);
  font-weight: 400;
  font-size: 24px;
  color: var(--purple-dark);
}

.edition {
  margin: 4px 0 0;
  font-size: 13.5px;
  color: var(--gray);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
  margin-top: 20px;
}

.size {
  font-size: 12.8px;
  color: var(--gray-light);
}

.note {
  margin: 20px 0 0;
  max-width: 66ch;
  font-size: 13.5px;
  color: var(--gray);
}
